export const capitalLettersReqExp = /[A-Z]+/g;
export const specialCharsRegExp = /[`!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]+/g;
export const emailRegExp = '^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$';
